export const SaveStates = Object.freeze({
  Blank: null,
  Idle: 'idle',
  Loading: 'loading',
  Processing: 'processing',
  Success: 'success',
  Errored: 'errored',
  Info: 'info'
});


/**
 * This Should match the Permissions as defined on the API
 * see app/lib/afflo/permission_names.rb
 */
export const PermissionNames = Object.freeze({
  AREA_INTERNAL: 'area_internal',
  AREA_EXTERNAL: 'area_external',
  AREA_ADMIN: 'area_admin',
  AREA_OPERATIONAL_REPORTS: 'area_operational_reports',
  INTERNAL_DASHBOARD_PLUGIN: 'internal_dashboard_plugin',
  INTERNAL_DASHBOARD_MANUAL: 'internal_dashboard_manual',
  INTERNAL_DASHBOARD_UNFINISHED_BUSINESS: 'internal_dashboard_unfinished_business',
  INTERNAL_DASHBOARD_INTERNAL_QA: 'internal_dashboard_internal_qa',
  INTERNAL_DASHBOARD_INTERNAL_SUPER_TEAMS: 'internal_dashboard_internal_super_teams',
  EXTERNAL_DASHBOARD_ACTIVE_OFFERS: 'external_dashboard_active_offers',
  EXTERNAL_DASHBOARD_ANALYTICS: 'external_dashboard_analytics',
  EXTERNAL_DASHBOARD_REPORTS: 'external_dashboard_reports',
  EXTERNAL_TRANSPLANT_CENTER_REPORTING: 'external_transplant_center_reporting',
  INTERNAL_MATCH_COMMUNICATION_TEMPLATES: 'internal_match_communication_templates',
  INTERNAL_MATCH_DECLINE_OFFER: 'internal_match_decline_offer',
  INTERNAL_MATCH_MANAGE_ALTERNATIVE_NOTIFICATIONS: 'internal_match_manage_alternative_notifications',
  INTERNAL_MATCH_ARO_RULES: 'internal_match_aro_rules',
  INTERNAL_USER_MANAGE_ON_CALL: 'internal_user_manage_on_call',
  INTERNAL_USER_MANAGE_PROFILE: 'internal_user_manage_profile',
  INTERNAL_USER_SCHEDULED_NOTIFICATIONS: 'internal_user_scheduled_notifications',
  INTERNAL_MATCH_QUICK_QUOTE: 'internal_match_quick_quote',
  INTERNAL_MATCH_CHECKLISTS: 'internal_match_checklists',
  INTERNAL_MATCH_CHECKLISTS_VERIFY: 'internal_match_checklists_verify',
  INTERNAL_MATCH_TAGS: 'internal_match_tags',
  ADMIN_USERS: 'admin_users',
  ADMIN_USERS_MASS_IMPORT: 'admin_users_mass_import',
  ADMIN_TEAMS: 'admin_teams',
  ADMIN_ROLES: 'admin_roles',
  ADMIN_TROUBLESHOOT_DONORS: 'admin_troubleshoot_donors',
  ADMIN_TROUBLESHOOT_MATCHES: 'admin_troubleshoot_matches',
  ADMIN_TROUBLESHOOT_ROBOCALL_REDUCTION: 'admin_troubleshoot_robocall_reduction',
  ADMIN_COMMUNICATION_TEMPLATES: 'admin_communication_templates',
  ADMIN_MEMBERSHIP_CATEGORIES: 'admin_membership_categories',
  ADMIN_ARO_RULES: 'admin_aro_rules',
  ADMIN_PROCEDURE_NOTES: 'admin_procedure_notes',
  ADMIN_INTEGRATIONS_OMNILIFE_WORKFLOWS: 'admin_integrations_omnilife_workflows',
  ADMIN_CONFIGURATIONS_ROBOCALL_REDUCTION: 'admin_configurations_robocall_reduction',
  ADMIN_ORGAN_AND_ORGAN_GROUPS: 'admin_organ_and_organ_groups',
  ADMIN_INTEGRATIONS_EMAIL_NOTIFICATIONS: 'admin_integrations_email_notifications',
  ADMIN_TRANSPLANT_CENTER_CONFIGURATIONS: 'admin_transplant_center_configurations',
  ADMIN_DASHBOARD_CONFIGURATIONS_INTERNAL_SUPER_TEAM: 'admin_dashboard_configurations_internal_super_team',
  ADMIN_UNOS_FINALIZED_OFFERS_CSV_BATCH: 'admin_unos_finalized_offers_csv_batch',
  ADMIN_UNOS_MASK_CSV: 'admin_unos_mask_csv',
  ADMIN_MATCH_CHECKLISTS: 'admin_match_checklists',
  ADMIN_MATCH_TAGS: 'admin_match_tags',
  OPERATIONAL_REPORTS_MONTHLY_TXC_REPORTING: 'operational_reports_monthly_txc_reporting',
  OPERATIONAL_REPORTS_ADMIN_REPORTING: 'operational_reports_admin_reporting',
  OPERATIONAL_REPORTS_MONTHLY_BUSINESS_REPORTING: 'operational_reports_monthly_business_reporting',
  OPERATIONAL_REPORTS_BUSINESS_OTHER_METRICS: 'operational_reports_business_other_metrics'
 })

/**
 * This should match the ServicesLevels as defined in the API
 * see: app/models/service_level.rb
 */
export const ServiceLevels =  {
  TRIAGE: { name: 'Triage', code: 'triage' },
  OFFER_HANDLING: { name: 'Offer Handling', code: 'offer_handling' },
  CASE_HANDLING: { name: 'Case Handling', code: 'case_handling' }
};
